import { PRICING_PLANNER_ADMIN } from '../../../shared/constants';
import { UserRole } from '../../../shared/types';

const isAdminUser = (roles: UserRole[]) => {
  if (roles && roles?.includes(PRICING_PLANNER_ADMIN)) {
    return true;
  }
  return false;
};

export default isAdminUser;
